export const googleAPIKey = process.env.REACT_APP_PUBLIC_GOOGLE_MAP_KEY
